export default "__VITE_ASSET__pcap1yWR__"